<div class="layout">
  <div class="col left">
    <h1>{{ title }}</h1>
    <!-- Schema tree view -->
    <div class="schema-tree" *ngIf="schemaTree; else noTree">
      <ul class="tree-root">
        <li class="tree-node">
          <div
            class="node-label root-label"
            (click)="restoreFullSchema()"
            [class.selected]="!selectedNode"
            [attr.aria-selected]="!selectedNode"
          >
            Root
          </div>
          <ul *ngIf="schemaTree?.length" class="tree-children">
            <li *ngFor="let node of schemaTree" class="tree-node">
              <div
                class="node-label"
                (click)="selectNode(node, $event)"
                [class.selected]="selectedNode === node"
                [attr.aria-selected]="selectedNode === node"
              >
                {{ node.name }}
              </div>
              <ul *ngIf="node.children?.length" class="tree-children">
                <li *ngFor="let child of node.children" class="tree-node">
                  <div
                    class="node-label"
                    (click)="selectNode(child, $event)"
                    [class.selected]="selectedNode === child"
                    [attr.aria-selected]="selectedNode === child"
                  >
                    {{ child.name }}
                  </div>
                  <ul *ngIf="child.children?.length" class="tree-children">
                    <li *ngFor="let gc of child.children" class="tree-node">
                      <div
                        class="node-label"
                        (click)="selectNode(gc, $event)"
                        [class.selected]="selectedNode === gc"
                        [attr.aria-selected]="selectedNode === gc"
                      >
                        {{ gc.name }}
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <ng-template #noTree>
      <p class="tree-empty" *ngIf="!loadingSchema && !loadSchemaError">
        No properties.
      </p>
      <p *ngIf="loadingSchema">Building tree…</p>
    </ng-template>
  </div>
  <div class="col middle">
    <div class="middle-header">
      <div class="path-bar">
        <div class="path-row">
          <input
            class="path-input"
            type="text"
            placeholder="Path (a.b.c)"
            [(ngModel)]="pathQuery"
            (input)="onPathInput($event)"
            (focus)="onPathFocus()"
            (blur)="onPathBlur()"
            (keydown)="onPathKeyDown($event)"
            [class.invalid]="pathQuery && !pathValid"
            aria-label="Schema path"
            aria-autocomplete="list"
            [attr.aria-expanded]="showPathSuggestions"
            aria-haspopup="listbox"
          />
          <button
            type="button"
            class="path-btn"
            (click)="askPath()"
            [disabled]="loadingGenAi || !pathQuery.trim() || !pathValid"
            aria-label="Ask about path"
          >
            ✨ Ask
          </button>
          <div
            class="path-autocomplete"
            *ngIf="showPathSuggestions"
            role="listbox"
            aria-label="Path suggestions"
          >
            <ul class="suggestions">
              <li
                *ngFor="let s of filteredPaths; let i = index"
                role="option"
                [attr.aria-selected]="i === activeSuggestionIndex"
                (mousedown)="applySuggestion(s)"
                [class.active]="i === activeSuggestionIndex"
              >
                {{ s }}
              </li>
            </ul>
          </div>
        </div>
        <div *ngIf="pathError" class="path-error">{{ pathError }}</div>
      </div>
      <div class="status-bar">
        <span *ngIf="loadingSchema">Loading schema…</span>
        <span *ngIf="loadSchemaError" style="color: #f55"
          >Error: {{ loadSchemaError }}</span
        >
        <span *ngIf="loadingGenAi" class="thinking">Thinking…</span>
      </div>
    </div>
    <div class="editor-wrapper">
      <ngx-monaco-editor
        class="editor"
        [(ngModel)]="schemaJson"
        [options]="editorOptions"
        (onInit)="onEditorInit($event)"
      ></ngx-monaco-editor>
    </div>
  </div>
  <div class="col right chat-col">
    <div class="chat-header">
      <span>AI Conversation</span>
      <div class="chat-header-actions">
        <button
          type="button"
          class="sys-toggle"
          (click)="toggleSystemInstructions()"
          [attr.aria-expanded]="showSystemInstructions"
          aria-controls="sysInstrPanel"
        >
          {{
            showSystemInstructions ? "Hide Instructions" : "Show Instructions"
          }}
        </button>
        <button
          type="button"
          class="chat-clear"
          (click)="clearSession()"
          [disabled]="sendingChat || !visibleChatMessages.length"
          aria-label="Restart AI chat session"
        >
          Restart
        </button>
      </div>
    </div>
    <div
      id="sysInstrPanel"
      *ngIf="showSystemInstructions"
      class="system-instructions"
    >
      <label for="sysInstr" class="sys-label">System Instructions</label>
      <textarea
        id="sysInstr"
        class="sys-textarea"
        [(ngModel)]="systemInstructions"
        rows="3"
        placeholder="System instructions for AI agent"
      ></textarea>
    </div>
    <div class="chat-messages" #chatScroll>
      <div
        *ngFor="let msg of visibleChatMessages"
        class="chat-msg"
        [ngClass]="msg.role"
      >
        <div class="role">{{ msg.role === "user" ? "You" : "AI" }}</div>
        <div class="content">{{ msg.content }}</div>
      </div>
      <div *ngIf="sendingChat" class="chat-msg ai pending">
        <div class="role">AI</div>
        <div class="content">Thinking…</div>
      </div>
      <div
        *ngIf="!visibleChatMessages.length && !sendingChat"
        class="chat-empty"
      >
        Select a part of the schema and provide a path to get started
      </div>
    </div>
    <form class="chat-input-row" (submit)="sendChat(); $event.preventDefault()">
      <input
        type="text"
        class="chat-input"
        #chatInputRef
        [(ngModel)]="chatInput"
        name="chatInput"
        placeholder="Clinican response…"
        [disabled]="sendingChat || !developerMessageSent"
      />
      <button
        type="submit"
        class="chat-send"
        [disabled]="sendingChat || !chatInput.trim() || !developerMessageSent"
      >
        Send
      </button>
    </form>
  </div>
</div>
